<template>
  <v-container>
    <div v-if="user?.tiimio_admin">
      <v-btn @click="$router.push('/reports/create')" v-tooltip="'Luo raportti'" color="primary">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Reports',
  data: () => ({
    report: {
      position: 0,
      id: 123,
      title: 456,
      tags: ['Etenijät', 'Kotiuttajat'],
      league_id: 2,
      created_by_admins: true,
      creator: 'aku@kettunen.com',
      master_filter: 'FILTER',
      selections: [],
      items: [
        {
          title: 'Etenijät',
          type: 'list',
          width: 6,
          times: true, // true if times false if events
          group_by: 'runner',
          columns: [
            {
              title: 'Etenijä',
              value: '$.runner_name'
            }
          ],
        }
      ]
    }
  }),
  computed: {
    ...mapGetters('user', [
      'user'
    ])
  },
  methods: {
    //
  }
}
</script>